import type React from "react";
import { useContext } from "react";

import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { NotificationBox } from "shared/atoms/NotificationBox/";
import { CurrentPatientContext } from "utils/contexts";

export const UserCourseNotificationBox: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { patient, setShowSelectTreatmentSidebar } = useContext(CurrentPatientContext);

  return (
    <NotificationBox
      icon={faTriangleExclamation}
      label={t("usercourse.missing_usercourse")}
      buttonText={t("usercourse.create_course_short")}
      color="orange"
      onClick={event => {
        event.stopPropagation();
        if (patient.schedule_version === 2) {
          setShowSelectTreatmentSidebar(true);
        } else {
          navigate(`/patients/${patient.id}/usercourse/new`);
        }
      }}
    />
  );
};
